<template>
  <div>
    <van-nav-bar
      :title="t('relatorios.title')"
      :border="false"
      class="custom-nav-bar"
    >
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div
      class="activity-header"
      :class="{ 'sticky': isSticky }"
    >
      <div class="tabs">
        <div
          v-for="(tab, idx) in tabs"
          :key="tab.value"
          :class="['tab-item', { active: idx === activeTab }]"
          @click="handleTabClick(idx)"
        >
          {{ tab.label }}
          <div v-if="idx === activeTab" class="tab-underline"></div>
        </div>
      </div>
    </div>

    <!-- 使用 v-show 而不是动态组件切换 -->
    <div class="tab-content">
      <AccountDetails v-show="activeTab === 0" />
      <BettingRecords v-show="activeTab === 1" />
      <BettingStatistics v-show="activeTab === 2" />
      <Other v-show="activeTab === 3" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from "@/components/Button"
import { useRouter } from 'vue-router'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import AccountDetails from './components/AccountDetails.vue'
import BettingRecords from './components/BettingRecords.vue'
import BettingStatistics from './components/BettingStatistics.vue'
import Other from './components/Other.vue'

const router = useRouter()
const { t } = useI18n()
const activeTab = ref(0)
const isSticky = ref(false)

const onClickLeft = () => {
  router.back()
}

const handleTabClick = (idx: number) => {
  activeTab.value = idx
}

const tabs = [
  { label: t('relatorios.accountDetailss'), value: t('relatorios.accountDetailss') },
  { label: t('relatorios.bettingRecordss'), value: t('relatorios.bettingRecordss') },
  { label: t('relatorios.report'), value: t('relatorios.report') },
  // { label: t('relatorios.others'), value: t('relatorios.others') },
]
</script>

<style lang="scss" scoped>
.custom-nav-bar{
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3), 0px -2px 22px 0px rgba(53,189,128,0.61);
  &>* {
    height: 100%;
  }
}

.activity-header {
  background: #004D37;
  padding: 0 10px;
  height: 47px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  z-index: 1000;
}

.activity-header.sticky {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.activity-header.sticky + * {
  margin-top: 47px;
}

.tabs {
  display: flex;
  border-bottom: 1px solid #2e7d32;
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
  scrollbar-width: none;
  height: 100%;
  align-items: center;
}

.tabs::-webkit-scrollbar {
  display: none;
}

.tab-item {
  position: relative;
  padding: 12px 12px;
  color: #40B665;
  cursor: pointer;
  font-weight: 500;
  font-size: 10px;
  transition: color 0.2s, background 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
  border-radius: 4px;
  justify-content: center;
  height: 100%;
}

.tab-item:last-child {
  margin-right: 0;
}

.tab-item.active {
  color: #ffffff;
  border-radius: 4px;
  font-weight: bold;
  z-index: 1;
}

.tab-item:active {
  background: rgba(255, 255, 255, 0.18);
}

.tab-item.active:active {
  background: rgba(255, 255, 255, 0.25);
}

.tab-underline {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -1px;
  height: 2px;
  width: calc(100%);
  background: #009F76;
  border-radius: 2px 2px 0 0;
  margin: 0 auto;
}

.tab-content {
  position: relative;
}
</style>

<route lang="json5">
{
  name: 'relatorios',
  meta: {
    title: 'Reports',
    i18n: 'menus.relatorios'
  }
}
</route>
